export default {
  projectDesc: '基于 <strong>Vue2</strong> 的输入内容建议插件，支持键盘快速选择',
  demo: {
    singleColumn: '字段匹配模式',
    custom: '使用函数类型的 "showField" 进行自定义建议项',
    placeholder: '未输入内容时的提示',
    disabled: '禁用插件',
    slot: '使用作用域插槽（scoped slot）自定义建议项',
    limit: '设置建议项最多显示个数（实例中设置了只显示 5 项）',
    raw: '响应项目选中事件，并输出选中的原始数据'
  },
  option: {
    data: '输入建议内容的数据源指定',
    keyField: '指定作为键值的字段',
    showField: '指定行显示内容的字段，也可以设置 function 自定义显示内容',
    limit: '设置建议项最多显示个数，设置为 0 则为无限制'
  },
  event: {
    values: '输出选中项目的原始数据'
  }
}
